import React, { FC } from 'react';
import { useValues } from './useValues';
import ServerStateContext from './Context';
import { IInitialServerProducts } from './actions/getInitialProducts';
import { IMinUser } from '@/Models/User/IUser';

interface IServerStateProviderProps {
  children: React.ReactNode;
  initialValue: IInitialServerProducts;
  initialUser?: IMinUser;
};

const ServerStateProvider: FC<IServerStateProviderProps> = ({ children, initialValue, initialUser }) => {
  const state = useValues(initialValue, initialUser);
  
  return (
    <ServerStateContext.Provider value={state}>
      { children }
    </ServerStateContext.Provider>
  )
}

export default ServerStateProvider;
